import actions from './manageUsers.actions'
import mutations from './manageUsers.mutations'

const state = {
  userGroups: [],
  usersForUserGroup: [],
  showUserGroupModal: false,
  selectedUserGroupInfo: {},
  showRemoveUserModal: false,
  userList: [],
  showUsersModal: false,
  userGroupsForUser: [],
  selectedUser: {},
  userHistory: [],
  userGroupHistory: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
